const STORAGE_KEY = 'onboarding_debug'
const PREFIX = '[Onboarding]'

const isEnabled = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1'
  } catch {
    return false
  }
}

export const enableOnboardingLog = () => {
  localStorage.setItem(STORAGE_KEY, '1')
  console.info(PREFIX, 'Debug logging enabled')
}

export const disableOnboardingLog = () => {
  localStorage.removeItem(STORAGE_KEY)
  console.info(PREFIX, 'Debug logging disabled')
}

export const onboardingLog = (label, ...args) => {
  if (!isEnabled()) return
  console.info(`${PREFIX} %c${label}`, 'color: #7c3aed; font-weight: bold', ...args)
}

if (typeof window !== 'undefined') {
  window.__onboardingDebug = { enable: enableOnboardingLog, disable: disableOnboardingLog }
}
